import React from "react";
import styled, { keyframes } from "styled-components";

export const PageLoader = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <LoaderOverlay>
      <LoaderContent>
        <Spinner />
        <LoaderText>Loading...</LoaderText>
      </LoaderContent>
    </LoaderOverlay>
  );
};

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const HEADER_HEIGHT = 74;

const LoaderOverlay = styled.div`
  position: fixed;
  top: ${HEADER_HEIGHT}px;
  left: 0;
  width: 100%;
  height: calc(100vh - ${HEADER_HEIGHT}px);
  background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 0.8)
    ),
    url("https://justact-api-uploads.s3.ap-south-1.amazonaws.com/13/1765967267695-70ad3b0e-a79b-4993-8bc9-3f93bd068774/landing-image.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 1200;
  pointer-events: all;
`;

const LoaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  text-align: center;
`;

const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #00818a;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoaderText = styled.p`
  font-size: 1.2rem;
  color: white;
  font-weight: 600;
  font-family: "Segoe UI", sans-serif;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
`;
